import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char, s_char_skills} from "../_signals/s_char";
import {ICharSkill} from "../_interfaces/ICharSkill";
import {TalentSkillSubscriber} from "../_helper/DataBehaves";
import skill_improvise from "../_data/skill_improvise";
import skill_creation from "../_data/skill_creation";
import {v4} from "uuid";
import MenuItem from "@mui/material/MenuItem";
import React from "react";

export const SkillsGet = (cid: string) => {
    fetch(apiAddress + "/char/skills/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('BESkills get reponse', data);
                if (data.hasOwnProperty('result')) {
                    const skills = data.result as ICharSkill[]

                    let toinsert_skill_creation = skill_creation
                    let toinsert_skill_improvise = skill_improvise
                    let exists: string[] = []

                    skills.forEach(s => {
                        toinsert_skill_creation = toinsert_skill_creation.filter(i => s.name !== i)
                        toinsert_skill_improvise = toinsert_skill_improvise.filter(i => s.name !== i)
                        exists.push(s.name)
                    })

                    toinsert_skill_improvise.forEach(s => {
                        let data_talente_skill = TalentSkillSubscriber.value.find(ts => ts.name === s);
                        if (data_talente_skill) {
                            const skill: ICharSkill = {
                                id: v4(),
                                cid: s_char.value.id,
                                name: s,
                                attribute: data_talente_skill.attribute,
                                lpstart: data_talente_skill.lps_skill ?? 100,
                                step: 0,
                                type: 0,
                                stepfree: 0,
                                strain: 0,
                                karma: false,
                                define: []
                            }
                            SkillsCreate(skill)
                            skills.push(skill)
                        }
                    })

                    toinsert_skill_creation.forEach(s => {
                        let data_talente_skill = TalentSkillSubscriber.value.find(ts => ts.name === s);
                        if (data_talente_skill) {
                            let define: string[] = [];
                            if (data_talente_skill.define_single) define = data_talente_skill.define_single;
                            if (data_talente_skill.define_multi) define = data_talente_skill.define_multi;
                            let step = 0
                            if (s === 'Lesen/Schreiben') step = 1
                            if (s === 'Kunsthandwerk') step = 1
                            if (s === 'Fremdsprachen') step = 2

                            const skill: ICharSkill = {
                                id: v4(),
                                cid: s_char.value.id,
                                name: s,
                                attribute: data_talente_skill.attribute,
                                lpstart: data_talente_skill.lps_skill ?? 100,
                                step: step,
                                type: 1,
                                stepfree: 0,
                                strain: 0,
                                karma: false,
                                define: []//define
                            }

                            SkillsCreate(skill)
                            skills.push(skill)
                        }
                    })

                    s_char_skills.value = skills
                }
            }
        )
        .catch((reason => {
            console.log('BESkills get catch', reason);
        }))
}

export const SkillsCreate = (skill: ICharSkill) => {
    fetch(apiAddress + "/char/skills/", createOptions('CREATE', skill))
        .then((res) => res.json())
        .then((data) => console.log('BESkills create reponse', data))
        .catch((reason => console.log('BESkills create catch', reason)))
}

export const SkillsUpdate = (skill: ICharSkill) => {
    fetch(apiAddress + "/char/skills/", createOptions('UPDATE', skill))
        .then((res) => res.json())
        .then((data) => console.log('BESkills update response', data))
        .catch((reason => console.log('BESkills update catch', reason)))
}

export const SkillsDelete = (skill: ICharSkill) => {
    fetch(apiAddress + "/char/skills/", createOptions('DELETE', skill))
        .then((res) => res.json())
        .then((data) => console.log('BESkills delete response', data))
        .catch((reason => console.log('BESkills delete catch', reason)))
}